import {EPermissions, ScreenProp} from 'src/app/models'

type TKeys =
  | 'SETTING'
  | 'SETTING_ORGANISASI'
  | 'SETTING_PERUSAHAAN'
  | 'SETTING_PERUSAHAAN_ADD'
  | 'SETTING_PERUSAHAAN_EDIT'
  | 'SETTING_PERUSAHAAN_DETAIL'
  | 'SETTING_DEPARTEMEN'
  | 'SETTING_DEPARTEMEN_ADD'
  | 'SETTING_DEPARTEMEN_EDIT'
  | 'SETTING_TEMPLATE_TUGAS_DUPLICATE'
  | 'SETTING_DEPARTEMEN_DETAIL'
  | 'SETTING_DEPARTEMEN_DETAIL_L3'
  | 'SETTING_TEMPLATE_TUGAS'
  | 'SETTING_TEMPLATE_TUGAS_ADD'
  | 'SETTING_TEMPLATE_TUGAS_EDIT'
  | 'SETTING_TEMPLATE_TUGAS_DETAIL'

const SettingScreens: Record<TKeys, ScreenProp> = {
  SETTING: {
    PATH: '/setting',
    TITLE: 'Pengaturan',
    TITLE_ALT: 'Pengaturan',
  },
  SETTING_ORGANISASI: {
    PATH: '/setting/my-organization',
    TITLE: 'Organisasi',
    TITLE_ALT: 'Organisasi',
    PERMISSION: [EPermissions.ORGANIZATION_READ],
  },
  SETTING_PERUSAHAAN: {
    PATH: '/setting/my-company',
    TITLE: 'Perusahaan',
    TITLE_ALT: 'Perusahaan',
    PERMISSION: [EPermissions.COMPANY_READ],
  },
  SETTING_PERUSAHAAN_ADD: {
    PATH: '/setting/my-company/add',
    TITLE: 'Perusahaan',
    TITLE_ALT: 'Perusahaan',
    PERMISSION: [EPermissions.COMPANY_CREATE],
  },
  SETTING_PERUSAHAAN_EDIT: {
    PATH: '/setting/my-company/edit/:id',
    TITLE: 'Perusahaan',
    TITLE_ALT: 'Perusahaan',
    PERMISSION: [EPermissions.COMPANY_UPDATE],
  },
  SETTING_PERUSAHAAN_DETAIL: {
    PATH: '/setting/my-company/detail/:id',
    TITLE: 'Perusahaan',
    TITLE_ALT: 'Perusahaan',
    PERMISSION: [EPermissions.COMPANY_READ],
  },
  SETTING_DEPARTEMEN: {
    PATH: '/setting/my-department',
    TITLE: 'Departemen',
    TITLE_ALT: 'Departemen',
    PERMISSION: [EPermissions.DEPARTMENT_READ],
  },
  SETTING_DEPARTEMEN_ADD: {
    PATH: '/setting/my-department/add',
    TITLE: 'Departemen',
    TITLE_ALT: 'Departemen',
    PERMISSION: [EPermissions.DEPARTMENT_CREATE],
  },
  SETTING_DEPARTEMEN_EDIT: {
    PATH: '/setting/my-department/edit/:id',
    TITLE: 'Departemen',
    TITLE_ALT: 'Departemen',
    PERMISSION: [EPermissions.DEPARTMENT_UPDATE],
  },
  SETTING_DEPARTEMEN_DETAIL: {
    PATH: '/setting/my-department/detail/:id',
    TITLE: 'Departemen',
    TITLE_ALT: 'Departemen',
    PERMISSION: [EPermissions.DEPARTMENT_READ],
  },
  SETTING_DEPARTEMEN_DETAIL_L3: {
    PATH: '/setting/my-department/detail',
    TITLE: 'Departemen',
    TITLE_ALT: 'Departemen',
    PERMISSION: [EPermissions.DEPARTMENT_READ],
  },

  SETTING_TEMPLATE_TUGAS: {
    PATH: '/setting/template-tugas',
    TITLE: 'Template Tugas',
    TITLE_ALT: 'Template Tugas',
    PERMISSION: [EPermissions.JOB_TEMPLATE_READ],
  },
  SETTING_TEMPLATE_TUGAS_ADD: {
    PATH: '/setting/template-tugas/add',
    TITLE: 'Template Tugas',
    TITLE_ALT: 'Buat Template',
    PERMISSION: [EPermissions.JOB_TEMPLATE_CREATE],
  },
  SETTING_TEMPLATE_TUGAS_EDIT: {
    PATH: '/setting/template-tugas/edit/:id',
    TITLE: 'Template Tugas',
    TITLE_ALT: 'Edit Template',
    PERMISSION: [EPermissions.JOB_TEMPLATE_UPDATE],
  },
  SETTING_TEMPLATE_TUGAS_DUPLICATE: {
    PATH: '/setting/template-tugas/duplicate/:id',
    TITLE: 'Template Tugas',
    TITLE_ALT: 'Duplicate Template',
    PERMISSION: [EPermissions.JOB_TEMPLATE_CREATE],
  },
  SETTING_TEMPLATE_TUGAS_DETAIL: {
    PATH: '/setting/template-tugas/detail/:id',
    TITLE: 'Template Tugas',
    TITLE_ALT: 'Detail Template',
    PERMISSION: [EPermissions.JOB_TEMPLATE_READ],
  },
}

export default SettingScreens
